/* eslint-disable max-classes-per-file */

/**
 * {
      code, // INSIGN Error code, number base
      name, // INSIGN Error name, string base
      message, // translated error message with i18n
      rawResponseData, // raw data of server error
      httpStatus // ❓❔
    }
 */
class ErrorHandler {
  constructor({
    code, name, message, rawResponseData, httpStatus,
  } = {}) {
    this.code = code
    this.name = name
    this.message = message || window.$i18next.t('error_message', { ns: 'common' })
    this.rawResponseData = rawResponseData || {}
    this.httpStatus = httpStatus
  }

  getErrorMessageWithCode({ code = this.code, message = this.message } = {}) {
    const serverErrorCode = this.rawResponseData.error?.code ? `(${this.rawResponseData.error?.code})` : ''
    const errorCode = `\n\n${window.$i18next.t('ERROR_CODE')}: ${code}${serverErrorCode}`

    return `${message}${errorCode}`
  }
}

/**
  {
    success: boolean,
    data: {}, // response data from server
    error: { // if success false,
      code, // INSIGN Error code, number base
      name, // INSIGN Error name, string base
      message, // translated error message with i18n
      rawResponseData, // raw data of server error
      httpStatus // ❓❔
    },
  }
 */
export default class ServiceHandler {
  constructor({ success, data, error } = {}) {
    this.success = success
    this.data = data
    this.error = new ErrorHandler(error)
  }

  getErrorModalData() {
    if (this.success) {
      return {}
    }

    return {
      message: this.error.getErrorMessageWithCode(),
    }
  }
}
